<footer>
  <mat-toolbar color="primary"> &copy; Qundo Technology </mat-toolbar>
</footer>
